import type { ShortcutCombination } from './keymap';
import { modifiersEqual } from './keymap';

const FUNCTION_KEY_PATTERN = /^F(1[0-2]|[1-9])$/;

/** Function keys fire even while an editable element has focus; every other binding does not. */
export const isFunctionKeyCombination = (
    combination: ShortcutCombination,
): boolean =>
    combination.matchOn === 'key' &&
    FUNCTION_KEY_PATTERN.test(combination.value);

export const matchesCombination = (
    event: KeyboardEvent,
    combination: ShortcutCombination,
): boolean => {
    const eventValue = combination.matchOn === 'code' ? event.code : event.key;
    return (
        eventValue === combination.value &&
        modifiersEqual(
            {
                ctrlKey: event.ctrlKey,
                shiftKey: event.shiftKey,
                altKey: event.altKey,
                metaKey: event.metaKey,
            },
            combination,
        )
    );
};

/** True while any modifier key is held — a key pressed with one is never a bare keystroke (e.g. `Ctrl+1` must not type a `1`). */
export const hasModifier = (event: KeyboardEvent): boolean =>
    event.ctrlKey || event.shiftKey || event.altKey || event.metaKey;

/** True for a keydown that never carries user intent: a held key repeating, or a key pressed mid-IME composition. */
export const isIgnorableKeydown = (event: KeyboardEvent): boolean =>
    event.repeat || event.isComposing;
